import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FuseFullscreenModule, FuseNavigationModule } from '@fleet/fuse';

import { CommonModule } from '@angular/common';
import { UserMenuModule } from '@fleet/auth-shared';
import { GroupViewControlModule } from '@fleet/ui/group-view-control/group-view-control.module';
import { FleetLayoutComponent } from './fleet-layout.component';

import { FuseLoadingBarModule } from '@fleet/fuse';

import { ExportModule } from '@fleet/export';

import { BillingBannerComponent } from '@fleet/billing';
import { UpdateBannerComponent, VersionBannerComponent } from '@fleet/version';
import { NetworkGroupSwitcherComponent } from '../../../network-group-switcher/network-group-switcher.component';

@NgModule({
  declarations: [FleetLayoutComponent],
  exports: [FleetLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    FuseFullscreenModule,
    FuseNavigationModule,
    GroupViewControlModule,
    UserMenuModule,
    FuseLoadingBarModule,
    UpdateBannerComponent,
    BillingBannerComponent,
    VersionBannerComponent,
    ExportModule,
    NetworkGroupSwitcherComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class FleetLayoutModule {}
